/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LightbulbIcon20Regular = forwardRef('LightbulbIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5.196 7.847a4.804 4.804 0 1 1 7.845 3.718c-.422.346-.792.816-.974 1.384a.75.75 0 1 0 1.428.458c.076-.236.247-.477.496-.681a6.304 6.304 0 1 0-7.982 0c.249.204.42.445.496.68a.75.75 0 1 0 1.428-.457c-.182-.568-.552-1.038-.974-1.383a4.793 4.793 0 0 1-1.763-3.72Z" }),
        React.createElement("path", { d: "M7.3 16h5.41a.75.75 0 1 0 0-1.5H7.3a.75.75 0 0 0 0 1.5Z" }),
        React.createElement("path", { d: "M7.845 18a.75.75 0 0 1 .75-.75h2.81a.75.75 0 0 1 0 1.5h-2.81a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { d: "M10.75 7.735a.75.75 0 0 0-1.5 0v4.483a.75.75 0 0 0 1.5 0V7.735Z" })));
});
